<template lang="pug">
v-list-group(
  :prepend-icon="menuItem.icon",
  append-icon="mdi-chevron-down",
  v-if="menuItem.type === 'MENU'",
  :active-class="active"
)
  template(v-slot:activator)
    v-list-item-content
      v-list-item-title {{ menuItem.description }}
  template(v-for="items in menuItem.children")
    f-menu-navigation(:key="items.menuCode", :menuItem="items")
v-list-item(@click="menuSelect(menuItem.shortName)", v-else)
  v-list-item-icon 
    v-icon {{ menuItem.icon }}
  v-list-item-content
    v-list-item-title {{ menuItem.description }}
</template>

<script>
export default {
  name: "FMenuNavigation",
  props: ["menuItem", "active"],
  methods: {
    menuSelect(name) {
      this.$router.push({ name: name }).catch((err) => {});
    },
  },
};
</script>